import { useRoute } from 'vue-router'
import type { RouteLocationRaw } from 'vue-router'

import type RouteParam from '@@/enums/RouteParam'
import type { BaseRoute } from '@@/types/Route'
import type { IbexaBaseItemFields } from '@@/types/Ibexa'

export const useAppRouting = () => {
  const { params, path, query } = useRoute()

  const getContentIdFromRouteParam = (routeParam: RouteParam): number => {
    const slug = params[routeParam] as string
    if (!slug) return -1
    const contentId = slug.split('_id:').slice(-1)[0]

    const numberRegex = /^[0-9]+$/

    if (numberRegex.test(contentId)) {
      return parseInt(contentId)
    }
    else {
      navigateTo('/404')
      return -1
    }
  }

  const getRouteWithParams = (route: BaseRoute, element?: IbexaBaseItemFields): RouteLocationRaw => {
    return {
      name: route.name,
      params: {
        ...params,
        ...(element && { [route.param as string]: createSlug(element.title, element.contentId) }),
      },
    }
  }

  const getParentRoute = (): RouteLocationRaw => {
    if (path === '/') return { path: '/' }

    return { path: getParentPath(path), query: query }
  }

  return {
    getContentIdFromRouteParam,
    getRouteWithParams,
    getParentRoute,
  }
}
